import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FaPhoneVolume } from 'react-icons/fa';
import { MdLocationOn, MdOutlineEmail } from 'react-icons/md';
import { Button, Col, Row } from 'react-bootstrap';
import CenterStage from '../../Components/CenterStage/CenterStage';
import SectionHeader from '../../Components/SectionHeader/SectionHeader';
import FeatureCardCarousel from '../../Components/FeaturesCardCarousal/FeatureCardCarousal';
import ShowcaseCarousel from '../../Components/ShowcaseCarousel/ShowcaseCarousel';
import FullImageText from '../../Components/FullImageText/FullImageText';
import imgHANSAFLEX_Ireland_Whoweare_service from '../../assets/WhoWeAre/HANSAFLEX_Ireland_Whoweare_service.webp';
import imgHANSAFLEX_HoseLogo from '../../assets/WhoWeAre/HANSAFLEX_Ireland_Hose.webp';
import imgHANSAFLEX_Kartons_Shop from '../../assets/WhoWeAre/HANSAFLEX_Kartons_Shop.webp';
import imgHANSAFLEX_Ireland_servicevan from '../../assets/WhoWeAre/HANSAFLEX_Ireland_servicevan.webp';
import imgHANSAFLEX_Ireland_Whoweare_Logistics from '../../assets/WhoWeAre/HANSAFLEX_Ireland_Whoweare_Logistics.jpg';
import HANSAFLEX_Customersupport from '../../assets/WhoWeAre/HANSAFLEX_Customersupport.png';
import imgHANSAFLEX_Ireland_Hose from '../../assets/WhoWeAre/HANSAFLEX_Ireland_Hose.webp';
import ImageText from '../../Components/ImageText/ImageText';
import imgHANSAFLEX_Ireland_Vannew from '../../assets/WhoWeAre/HANSAFLEX_Ireland_Vannew.webp';
import imgHANSAFLEX_Ireland_who_we_are_stage from '../../assets/WhoWeAre/HANSAFLEX_Ireland_who_we_are_stage.webp'
import ThreeDImageCarousel from '../../Components/CircleCarousel/CircleCarousel';
import imgHANSAFLEX_Ireland_Warehouse_1 from '../../assets/WhoWeAre/HANSAFLEX_Ireland_Warehouse_1.webp';
import imgHANSAFLEX_Ireland_Warehouse_2 from '../../assets/WhoWeAre/HANSAFLEX_Ireland_Warehouse_2.webp';
import imgHANSAFLEX_Ireland_Warehouse_3 from '../../assets/WhoWeAre/HANSAFLEX_Ireland_Warehouse_3.webp';
import imgHANSAFLEX_Ireland_Warehouse_4 from '../../assets/WhoWeAre/HANSAFLEX_Ireland_Warehouse_4.webp';
import imgHANSAFLEX_Ireland_Warehouse_5 from '../../assets/WhoWeAre/HANSAFLEX_Ireland_Warehouse_5.webp';
import imgHANSAFLEX_Ireland_Warehouse_7 from '../../assets/WhoWeAre/HANSAFLEX_Ireland_Warehouse_7.webp';
import imgHANSAFLEX_Ireland_Warehouse_8 from '../../assets/WhoWeAre/HANSAFLEX_Ireland_Warehouse_8.webp';

function WhoWeAre() {
    const { t } = useTranslation();

    // features card carousel data
    const featuresData = [
        {
            title: "Customer support",
            description: "Offering expert advice and assistance to our customers in Ireland.",
            image: HANSAFLEX_Customersupport
        },
        {
            title: "Extensive stock availability",
            description: "We have stocks of products around 13000 units!",
            image: imgHANSAFLEX_Kartons_Shop
        },
        {
            title: "Premium quality hoses",
            description: "Experience our unmached Quality",

            image:imgHANSAFLEX_HoseLogo
        }
        // Add more objects for additional FeaturesCard data
    ];

    const carouselItems = [
        {
            imgSrc: imgHANSAFLEX_Ireland_Whoweare_service,
            title: 'Easy-Order Easy-Delivery',
            description: 'At HANSA-FLEX Ireland we provide best of customer service and take care that the quality product is delivered.'
        },

        {
            imgSrc: imgHANSAFLEX_Ireland_Whoweare_Logistics,
            title: 'We Make it, We deliver it',
            description: 'HANSA‑FLEX Ireland ensures hoses and fittings are consistently stocked, guaranteeing uninterrupted operations for clients. With a proactive approach, we prioritize maintaining ample inventory, delivering reliability and efficiency to meet diverse hydraulic system needs.'
        }
    ];

    const Pumps = () => { }
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    const pump1 = {
        image: imgHANSAFLEX_Ireland_servicevan,
        title: 'The principle of success is called the partnership system',
        description: '',
        listItems: ["It is the range and quality of products and services that make the company a valuable partner.", "In a key technology such as hydraulics, the customer has a preference for solutions from a single source.", "The extensive network of subsidiaries opens the door to the world of hydraulic services from HANSA-FLEX."],
        buttonName: "ALL GEAR PUMPS"
    };

        const pump2 = {
        image: imgHANSAFLEX_Ireland_Hose,
        title: "Our customers' machines, factories and systems must always work",
        description: 'Safe, reliable and uninterrupted. Wherever you need it. Our MHS mobile units and our branches are available 24 hours a day, 365 days a year. In addition, the safety of people and the environment is part of the HANSA-FLEX commitment to our customers, we are constantly improving the technology of our products, to maintain the exceptional quality of our work.',
        // listItems: [""],
        buttonName: "ALL AXIAL PISTON PUMPS"
    }
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    const items = [
        {
            image: imgHANSAFLEX_Ireland_Warehouse_1,
        },
        {
            image: imgHANSAFLEX_Ireland_Warehouse_2,
        },
        {
            image: imgHANSAFLEX_Ireland_Warehouse_3,
        },
        {
            image: imgHANSAFLEX_Ireland_Warehouse_4,
        },
        {
            image: imgHANSAFLEX_Ireland_Warehouse_5,
        },
        {
            image: imgHANSAFLEX_Ireland_Warehouse_7,
        },
        {
            image: imgHANSAFLEX_Ireland_Warehouse_8,
        },
    ]

    return (
        <div>
            <CenterStage imageSrc={imgHANSAFLEX_Ireland_who_we_are_stage} title={"Welcome to HANSA-FLEX Ireland Ltd."} 
            paragraph={"At HANSA-FLEX Ireland Ltd., we are your trusted partner for hydraulic solutions, offering exceptional expertise and innovative technologies to meet your needs. As part of the globally renowned HANSA-FLEX network, we are committed to delivering high-quality products and services that empower industries to perform at their best. From customized hydraulic systems to efficient maintenance solutions, we are here to drive your success with precision, reliability, and excellence."} />

            <FullImageText
                imageSrc={imgHANSAFLEX_Ireland_Vannew}
                altText="Service Mobile Van"
                title="Your Hydraulic Solutions on Wheels"
                paragraph="Our service mobile van is equipped with the latest tools and technology to provide on-site hydraulic solutions. Whether it's urgent repairs or routine maintenance, our expert team is ready to deliver exceptional service directly to your location, ensuring minimal downtime and maximum efficiency."
                imageWidth={1}
            />

            <div>
                <ImageText data={pump1} /> <br /><br />
                <ImageText data={pump2} left={false} /> <br /><br />

            </div>

            {/* <div>
                {isLaptop && (
                    <Promoter
                        title={promoterTitle}
                        checklistItems={promoterChecklistItems}
                        btnLabel1={"Find Out More !"}
                        imageUrl={imgTeams}
                    />
                )}
            </div> */}
            <SectionHeader title={"Our Warehouse"} paragraph={"Relocated to 8000sq feet warehouse July 2021 with dedicated trade counter and over 12000  lines items in stock "} />
            <ThreeDImageCarousel items={items}/>

            <div className='div-gray'>
                <SectionHeader title={"Why choose us?"} paragraph={"We are the epitome of excellence, renowned for our unwavering commitment to quality and customer satisfaction. We provide unrivaled solutions tailored to your needs."} />
                <FeatureCardCarousel featuresData={featuresData} />
            </div>


            <div>

                <br /><br /><br /><br />
                <ShowcaseCarousel carouselItems={carouselItems} isExploreButton={false} descDisplay='block' carouselType={1} />
            </div>

            <br /><br /><br />
            <br /><br /><br />

            <div className="text-center div-gray">
                <SectionHeader
                    title={"Explore about HANSA-FLEX Group"}
                    paragraph={"HANSA‑FLEX is a global family-run company and one of the world’s leading system partners for fluid technology. In the last business year, more than 5,000 employees in 40 countries achieved a turnover of EUR 570 million."} />
                <br />
                <Button variant="danger" href={"https://www.hansa-flex.de/en/company/"} target="_blank" style={{ boxShadow: '10px 10px 20px rgba(0, 0, 0, 0.2)' }}>{t("Learn more about HANSA-FLEX")}</Button>

                <br /><br /><br />
            </div>


            <div>

                <br /><br /><br /><br />

                <div style={{ backgroundColor: '#30557d', padding: '20px', color: 'white', paddingLeft: '10%' }}>
                    <Row>
                        <Col xs={12} md={6}>
                            <h2>{t("Contact details")}:</h2>
                            <p>{t("For further information, assistance or collaboration, please do not hesitate to contact us")}:</p>
                            <p> <MdLocationOn /> {t("Address")}: <a href="https://www.google.com/maps/place/HANSA-FLEX+(NI)/@54.5442439,-6.0201206,17z/data=!3m1!4b1!4m6!3m5!1s0x4861a728a4066a45:0xc6c8deac667e23e2!8m2!3d54.5442439!4d-6.0201206!16s%2Fg%2F11g4j06f9c?entry=ttu&g_ep=EgoyMDI1MDcxNi4wIKXMDSoASAFQAw%3D%3D" style={{ textDecoration: 'none', color: 'white' }} > HANSA-FLEX Ireland, 74 Derriaghy Industrial Park, BT17 9HU Dunmurry,Co. Antrim, Northern Ireland </a></p>
                            <p> <MdOutlineEmail /> {t("Email")}: <a href="mailto:bbl@hansa-flex.com" style={{ textDecoration: 'none', color: 'white' }}> ni.info@hansa-flex.com</a></p>
                            <p> <FaPhoneVolume /> {t("Phone")}: <a href="tel:+44 028 90833813" style={{ textDecoration: 'none', color: 'white' }} >(0044) 028 90833813 (NI)</a></p>
                            <p> <FaPhoneVolume /> {t("Phone")}: <a href="tel:+353 01 6251962" style={{ textDecoration: 'none', color: 'white' }} >(00353) 01 6251962 (ROI)</a></p>
                        </Col>
                    </Row>
                </div>


            </div>


        </div>
    );
};

export default WhoWeAre